import styled from "styled-components";

import phoneRedIcon from "../../../../assets/Mayo/Phone_Red.svg";

export default function HealthWarning() {
  return (
    <Container>
      <Text> If you have active bleeding or swelling of the puncture site: </Text>
      <Icon 
        src={phoneRedIcon}
      />
      <Text style={{fontWeight: 500, marginBottom: 25}}>
        Call 911 or your designated emergency number. Do not drive yourself to the hospital!
      </Text>
      <Text> Lie down and apply firm pressure with two or three fingers over the puncture site until help arrives. </Text>
    </Container>
  );
}


const Container = styled.div`
  margin-inline: 22px;
  padding: 21px 26px 27px 29px;
  border: 2px solid rgba(240, 42, 76, .5);
  border-radius: 15px;
`

const Text = styled.p`
  font-size: 19px;
  margin: 0;
`

const Icon = styled.img`
  margin-top: 15px;
  margin-bottom: 15px;
`